import camelcaseKeys from "camelcase-keys";
import moment from "moment-timezone";

import * as date from "@/utils/date";

import {
  DELETE_CHAT_NOTIFICATION,
  MARK_ALL_CHAT_NOTIFICATIONS_READ,
  MARK_CHAT_NOTIFICATION_READ,
  RESET,
  SET_ALL_CHAT_NOTIFICATIONS,
  SET_LAST_NOTIFICATION,
  SET_NOTIFICATION,
  SET_NOTIFICATION_TYPE,
} from "./notifications.actionTypes";
import * as selectors from "./notifications.selectors";

export const setNotificationType = (payload) => (dispatch) => {
  dispatch({
    type: SET_NOTIFICATION_TYPE,
    payload,
  });
};

export const setNotification = (type, message) => (dispatch) => {
  dispatch(setNotificationType(type));

  dispatch({
    type: SET_NOTIFICATION,
    payload: message,
  });
};

export const setLastNotification = (payload) => (dispatch) => {
  dispatch({
    type: SET_LAST_NOTIFICATION,
    payload,
  });
};

const addTimestamp = (item) => {
  const parsed = item.createdTimestamp
    ? moment(item.createdTimestamp).tz(date.getCurrentUserTimezone())
    : null;

  return {
    ...item,
    // Treat a malformed timestamp the same as a missing one (null) so byTimestamp
    // sorts it to the end instead of producing a NaN comparison that breaks sort order.
    createdTimestampUnix: parsed?.isValid() ? parsed.unix() : null,
  };
};

// Sort ascending by timestamp, placing notifications without a timestamp at the
// end. Avoids the null -> 0 coercion that would otherwise sort them as epoch 0.
const byTimestamp = (a, b) => {
  if (a.createdTimestampUnix == null && b.createdTimestampUnix == null) {
    return 0;
  }
  if (a.createdTimestampUnix == null) {
    return 1;
  }
  if (b.createdTimestampUnix == null) {
    return -1;
  }
  return a.createdTimestampUnix - b.createdTimestampUnix;
};

export const setAllChatNotifications = (payload) => (dispatch) => {
  const notifications = camelcaseKeys(payload, { deep: true })
    .map(addTimestamp)
    .sort(byTimestamp);

  dispatch({
    type: SET_ALL_CHAT_NOTIFICATIONS,
    payload: notifications,
  });
};

export const receiveChatNotification = (payload) => (dispatch, getState) => {
  const message = camelcaseKeys(payload, { deep: true });
  const existing = selectors.getAllChatNotifications(getState());
  const index = existing.findIndex((item) => item.id === message.id);
  const timestamped = addTimestamp(message);

  const updated =
    index >= 0
      ? existing.map((item) => (item.id === message.id ? timestamped : item))
      : [...existing, timestamped];

  updated.sort(byTimestamp);

  dispatch({
    type: SET_ALL_CHAT_NOTIFICATIONS,
    payload: updated,
  });
};

export const markChatNotificationRead = (id) => (dispatch) => {
  dispatch({
    type: MARK_CHAT_NOTIFICATION_READ,
    payload: id,
  });
};

export const markAllChatNotificationsRead = () => (dispatch) => {
  dispatch({
    type: MARK_ALL_CHAT_NOTIFICATIONS_READ,
  });
};

export const deleteChatNotification = (id) => (dispatch) => {
  dispatch({
    type: DELETE_CHAT_NOTIFICATION,
    payload: id,
  });
};

export const reset = () => (dispatch) => {
  dispatch({ type: RESET });
};
